import React from 'react';
import { formatCurrency } from '../../../../../../../../../../utils/functions';
import './UserStatsSection.scss';

interface UserStats {
  name: string;
  total: number;
  count: number;
  avg_total: number;
  tip: number;
  avg_tip: number;
  cancelled: number;
  cancelled_amount: number;
  avg_cancelled: number;
  avg_tip_variation: number | null;
}

interface UserStatsCardProps {
  user: UserStats;
}

export const UserStatsCard: React.FC<UserStatsCardProps> = ({ user }) => {
  return (
    <div className="sb-user-card">
      <div className="sb-user-header">
        <span className="sb-user-name">{user.name}</span>
        <span className="sb-user-count">{user.count} recibos</span>
      </div>
      <div className="sb-row">
        <span className="sb-label">Total Ventas</span>
        <span className="sb-value">{formatCurrency(user.total)}</span>
      </div>
      <div className="sb-row">
        <span className="sb-label">Promedio por Recibo</span>
        <span className="sb-value">{formatCurrency(user.avg_total)}</span>
      </div>
      <div className="sb-row">
        <span className="sb-label">Propinas</span>
        <span className="sb-value">{formatCurrency(user.tip)}</span>
      </div>
      {user.cancelled > 0 && (
        <div className="sb-row">
          <span className="sb-label">Cancelados</span>
          <span className="sb-value">{user.cancelled} ({formatCurrency(user.cancelled_amount)})</span>
        </div>
      )}
    </div>
  );
};

interface UserStatsSectionProps {
  usersStats: { [userId: string]: UserStats };
  title?: string;
}

const UserStatsSection: React.FC<UserStatsSectionProps> = ({ usersStats, title }) => {
  if (!usersStats || Object.keys(usersStats).length === 0) {
    return null;
  }

  return (
    <div className="sb-section">
      <h4 className="sb-section-title">{title ?? 'Estadísticas por Usuario'}</h4>
      {Object.values(usersStats).map((user) => (
        <UserStatsCard key={user.name} user={user} />
      ))}
    </div>
  );
};

export default UserStatsSection;
